/* eslint-disable react/prop-types */
import React from "react";
import CircularProgress from "@material-ui/core/CircularProgress";
import Backdrop from "@material-ui/core/Backdrop";
import Box from "@material-ui/core/Box";
import { makeStyles } from "@material-ui/core/styles";

const useStylesLoad = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
}));

export const Iframe = ({ source }) => {
  const classesLoad = useStylesLoad();
  if (!source) {
    return (
      <Backdrop className={classesLoad.backdrop} open={true}>
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          height="100%"
        >
          <CircularProgress color="inherit" />
        </Box>
      </Backdrop>
    );
  }
  const src = source;
  return (
    <div>
      <iframe src={src} style={{ width: "100%", height: 485 }}></iframe>
    </div>
  );
};
